<script setup lang="ts">
  import SwitchAccount from "@/components/shared/SwitchAccount.vue"
  import Card from "@/components/ui/card/Card.vue"
  import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
  } from "@/components/ui/sheet"

  defineProps<{
    open: boolean
  }>()

  const emit = defineEmits<{
    "update:open": [value: boolean]
  }>()
</script>

<template>
  <Sheet :open="open" @update:open="(value) => emit('update:open', value)">
    <SheetContent
      side="bottom"
      size="auto"
      class="overflow-y-auto"
      data-testid="switch-account-sheet"
    >
      <SheetHeader id="account-selection-heading" class="mb-9">
        <SheetTitle>Select an account</SheetTitle>
      </SheetHeader>
      <Card>
        <SwitchAccount
          :open="open"
          @update:open="(value) => emit('update:open', value)"
        />
      </Card>
    </SheetContent>
  </Sheet>
</template>
